import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/header/header.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetsCatalogWeb"] */ "/vercel/path0/src/components/widgetsCatalogWeb/widgetsCatalogWeb.comp.tsx");
